
import React, { Fragment } from 'react'
import { components } from 'react-select'

const { ValueContainer, Placeholder } = components

export default function CustomValueContainer({ children, ...props }) {
  const renderSelectedCount = (selectedCount) => {
    return selectedCount > 0 ? `${selectedCount} Selected` : ''
  }

  return (
    <ValueContainer {...props}>
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        {props.getValue().length > 0 ? (
          <div style={{ fontWeight: '500', padding: '0 8px', flex: 1 }}>
            {renderSelectedCount(props.getValue().length)}
          </div>
        ) : (
          <Placeholder {...props} isFocused={props.isFocused}>
            {props.selectProps.placeholder}
          </Placeholder>
        )}
      </div>
      {React.Children.map(children, (child) => {
        return (
          <Fragment>{child && child.key !== 'placeholder' ? child : null}</Fragment>
        )
      })}
    </ValueContainer>
  )
}
